<template>
  <section id="about" class="cr-section about-area section-padding-sm "  >
    <Loading :loaded="loaded"></Loading>
    <div class="container">

     <div v-html="content"></div>
    </div>
  </section>
</template>

<script>
import ImageLazy from './ImageLazy'
import Loading from './Loading'

export default {
  name: 'HomePageContent',
  components: {ImageLazy, Loading},
  data () {
    return {
      loaded: false,
      content: []
    }
  },
  mounted () {
    this.getSlides()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getSlides()
    })
  },
  methods: {
    getSlides ($event) {
      this.axios.get(this.$host + 'page/cimlap').then(resp => {
        this.content = resp.data.data.content
        this.loaded = true
      }).catch(() => { this.loaded = true })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomePageContent.vue